import React from "react";
import { createApp } from "../../../api";
import Track from "../../../track";
class StepOneForm extends React.Component {
  state = {
    url: "",
    loading: false,
    errMessage: "",
    skipAutoFetch:false,
    errType:''
  };
  handleChange=key =>(e) =>{
    this.setState({ [key]: e.target.value });
  }
  handleCheckBox=key =>(e) =>{
    this.setState({ [key]: e.target.checked });
  }
  submitUrl = () => {
    if (this.state.url === "") {
      return this.setState({
        errMessage: "Please enter a URL"
      });
    }
    Track.event({
      category: "PWA2APK",
      action: "Create",
    });
    this.setState({ loading: true, errMessage: "" }, () => {
      createApp({ url: this.state.url,skip_auto_fetch: this.state.skipAutoFetch }).then(data => {
        if (data.status) {
          this.setState({
            loading: false
          });
          this.props.history.push("/pwa-to-apk/create/" + data.id);
          
        } else {
          if (data.error === "NO_MANIFEST") {
            this.setState({ loading: false, errType:'NO_MANIFEST' });
          } else if (data.error === "INVALID_URL") {
            const message = `Please check if you have entered url correctly or not. Use https:// before url in case you forgotten.`;
            this.setState({ loading: false, errMessage: message });
          }

        }
      });
    });
  };
  render() {
    return (
      <div className="step-1 col-sm-12 m-auto">
        <h3>Provide PWA url</h3>
        <h6 className="mb-4">
          Provide the link to PWA for which Android App is required. You will be
          asked to verify ownership of the website in the next steps.
        </h6>
        <div className="form-group mb-4">
          <input
            name="url"
            type="url"
            className="form-control"
            onChange={this.handleChange('url')}
            value={this.state.url}
            placeholder="Enter your url"
            required
          />
        </div>
         {this.state.errMessage ? (
          <div className="alert alert-danger" role="alert">
            {this.state.errMessage}
          </div>
        ) : (
          ""
        )}
        <button className="btn btn-success w-100" onClick={this.submitUrl}>
          {this.state.loading ? (
            <span
              className="spinner-grow spinner-grow-sm mr-4"
              role="status"
              aria-hidden="true"
            />
          ) : (
            ""
          )}
          {this.state.loading ? "Checking URL" : "Get Started"}
        </button>
        {
        this.state.errType === "NO_MANIFEST" ? 
        <div className="nopwa-url mt-5">
          <div className="nopwa-url-msg d-flex">
            <img
              src="https://storage.googleapis.com/appilder_cdn/wordpress-theme/pwa-apk/images/nopwa-url.png"
              alt=""
            />
            <div className="ml-4  my-auto">
              <h4>Oh oo...</h4>
              <p>
                It Appears that url is not a PWA site. Please enter PWA site to
                continue.
              </p>
            </div>
          </div>
          <div className="pwa-sure mt-3">
              <input type="checkbox" className="mb-3" name="skipAutoFetch" id="" checked={this.state.skipAutoFetch} onChange={this.handleCheckBox('skipAutoFetch')} />  I'm sure its a PWA
              <button className="btn btn-secondary w-100" onClick={this.submitUrl}>Continue to Next step</button>
          </div>
          <div className="nonpwa-app mt-3 mb-3 text-right">
            <h5>
              Want to create an <strong>Android App for Non-PWA sites?</strong>
            </h5>
            <a href="https://appmaker.xyz/webapp" id="" className="btn btn-secondary">
              Click Here
            </a>
          </div>
        </div> : ''
        }       
      </div>
    );
  }
}

export default StepOneForm;
